import Request from "../request";
import { AuctionInquiryStatus, PaymentStatus } from "constants/consultation";

const request = new Request();

export interface ConsultationStats {
  auction_allcare_count: string;
  npl_allcare_count: string;
  bid_agent_count: string;
  rights_analysis_count: string;
  auction_consultation_count: string;
}

export interface ConsultationItem {
  ai_id: number;
  user_key: string;
  product_id: number | null;
  product_name: string | null;
  service_category:
    | "AUCTION_ALLCARE"
    | "NPL_ALLCARE"
    | "BID_AGENT"
    | "RIGHTS_ANALYSIS"
    | "AUCTION_CONSULTATION";
  inquiry_category: string | null;
  name: string;
  phone: string;
  email: string;
  property_type: string | null;
  case_no: string | null;
  item_no: string | null;
  content: string;
  current_status: AuctionInquiryStatus;
  requires_approval: boolean;
  requires_payment: boolean;
  created_at: string;
  user_name: string;
  user_email: string;
  user_tel: string;
  payment_status: PaymentStatus;
}

export type ConsultationTimelineType = "STATUS" | "ASSIGN" | "MEMO" | string;

export interface ConsultationTimelineEntry {
  type: ConsultationTimelineType;
  value: string | null;
  prev_value: string | null;
  created_at: string;
}

export interface ConsultationDetailItem extends ConsultationItem {
  product_price: number | null;
  assignee_name: string | null;
  memo: string | null;
  assigned_at: string | null;
  user_login_type: "C" | "K" | "N" | "G" | string;
  user_id: string | null;
  timeline: ConsultationTimelineEntry[];
}

export interface ConsultationListResponse {
  list: ConsultationItem[];
  totalCount: number;
  stats: ConsultationStats;
}

export class ConsultationService {
  static list = async (params: {
    search?: string;
    serviceCategory?: string;
    status?: string;
    sort?: string;
    limit: number;
    page: number;
  }): Promise<ConsultationListResponse> => {
    const query = new URLSearchParams();
    if (params.search) query.set("search", params.search);
    if (params.serviceCategory) query.set("serviceCategory", params.serviceCategory);
    if (params.status) query.set("status", params.status);
    if (params.sort) query.set("sort", params.sort);
    query.set("limit", String(params.limit));
    query.set("page", String(params.page));

    const { data } = await request.get(`/admin/auction/inquiry?${query.toString()}`);
    return data?.data ?? data;
  };

  static getDetail = async (aiId: number | string): Promise<ConsultationDetailItem> => {
    const { data } = await request.get(`/admin/auction/inquiry/${aiId}`);
    return data?.data ?? data;
  };

  static updateStatus = async (aiId: number | string, status: AuctionInquiryStatus) => {
    await request.patch(`/admin/auction/inquiry/${aiId}/status`, { status });
  };

  static updateAssignee = async (aiId: number | string, name: string) => {
    await request.patch(`/admin/auction/inquiry/${aiId}/assignee`, { name });
  };

  static updateMemo = async (aiId: number | string, memo: string) => {
    await request.patch(`/admin/auction/inquiry/${aiId}/memo`, { memo });
  };
}
